<app-ot-breadcrumbs state="person" [city]="city" [otEvent]="otEvent"></app-ot-breadcrumbs>

<div class="container-fluid" *ngIf="otEventInfo && (otEventInfo.full || !otEventInfo.otEvent.registrationEnabled)">
  <div class="row">
    <div class="col-lg-8">
      <div class="alert alert-danger" role="alert">
        {{ (otEventInfo.full ? 'error_otEventIsFull' : 'error_otEventRegistrationDisabled') | l10n }}
      </div>
    </div>
    <div class="col-lg-4">
      <div class="card selected-event-card">
        <div class="card-body">
          <h5>{{ 'registration_selectedOtEvent' | l10n }}</h5>
          <app-ot-event-info [otEvent]="otEvent"></app-ot-event-info>
        </div>
      </div>
    </div>
  </div>
</div>

<form #personForm="ngForm" novalidate *ngIf="otEventInfo && otEventInfo.otEvent.registrationEnabled && ! otEventInfo.full">
  <div class="container-fluid">
    <div class="row personal-data-form-table">
      <div class="col-lg-9">
        <h1>{{ 'personalData_title' | l10n }}</h1>
        <p>{{ 'personalData_info' | l10n }}</p>

        <div class="form-group">
          <div class="col-sm-8 offset-md-4">
            <div class="personal-data-name-format-msg">
              <fa-icon [icon]="['fas', 'user']"></fa-icon>
              {{ 'personalData_nameFormat_info' | l10n }}
            </div>
          </div>
        </div>
        <div class="form-group row personal-data-field-firstName">
          <label for="firstName" class="col-sm-4 col-form-label col-form-label-sm required">{{ 'person_firstName' | l10n }}</label>
          <div class="col-sm-8">
            <input id="firstName" name="firstName" type="text" class="form-control" [(ngModel)]="registration.person.firstName" placeholder="{{ 'personalData_firstName_placeholder' | l10n }}" #firstName="ngModel" required />
            <div *ngIf="(submitted || firstName.dirty) && firstName.invalid" class="validationError">
              <span *ngIf="firstName.errors.required">{{ 'validation_required' | l10n:['#person_firstName'] }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row personal-data-field-lastName">
          <label for="lastName" class="col-sm-4 col-form-label col-form-label-sm required">{{ 'person_lastName' | l10n }}</label>
          <div class="col-sm-8">
            <input id="lastName" name="lastName" type="text" class="form-control"
                #lastName="ngModel"
                [(ngModel)]="registration.person.lastName"
                placeholder="{{ 'personalData_lastName_placeholder' | l10n }}" required />
            <div *ngIf="(submitted || lastName.dirty) && lastName.invalid" class="validationError">
              <span *ngIf="lastName.errors.required">{{ 'validation_required' | l10n:['#person_lastName'] }}</span>
            </div>
          </div>
        </div>

        <div class="form-separator"></div>

        <div class="form-group row personal-data-field-birthdate" *ngIf="otEvent.organization.personHasFullBirthdate">
          <label for="birthdate" class="col-sm-4 col-form-label col-form-label-sm required">{{ 'person_birthdate' | l10n }}</label>
          <div class="col-sm-8">
            <div class="input-group">
              <input type="text" name="birthdate" ngbDatepicker
                  #birthdate="ngModel"
                  #birthdateDatepicker="ngbDatepicker"
                  [(ngModel)]="registration.person.birthdate"
                  (dateSelect)="onDateSelect($event)"
                  class="form-control" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="birthdateDatepicker.toggle()" type="button">
                  <fa-icon icon="calendar-alt"></fa-icon>
                </button>
              </div>
            </div>
            <div *ngIf="(submitted || birthdate.dirty) && birthdate.invalid" class="validationError">
              <span *ngIf="birthdate.errors.required">{{ 'validation_required' | l10n:['#person_birthdate'] }}</span>
              <span *ngIf="! birthdate.errors.required">{{ 'validation_date' | l10n }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row personal-data-field-birthdateYear" *ngIf="! otEvent.organization.personHasFullBirthdate">
          <label for="birthdateYear" class="col-sm-4 col-form-label col-form-label-sm required">{{ 'person_birthdateYear' | l10n }}</label>
          <div class="col-sm-8">
            <input id="birthdateYear" name="birthdateYear" type="number" #birthdateYear="ngModel" [(ngModel)]="formData.birthdateYear" required min="1900" max="2039" class="form-control" />
            <div *ngIf="(submitted || birthdateYear.dirty) && birthdateYear.invalid" class="validationError">
              <span *ngIf="birthdateYear.errors.min || birthdateYear.errors.max || birthdateYear.errors.number">{{ 'validation_birthdateYear' | l10n }}</span>
              <span *ngIf="birthdateYear.errors.required">{{ 'validation_required' | l10n:['#person_birthdateYear'] }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row personal-data-field-email">
          <label for="email" class="col-sm-4 col-form-label col-form-label-sm required">{{ 'person_email' | l10n }}</label>
          <div class="col-sm-8">
            <input id="email" name="email" type="email" class="form-control" #email="ngModel" [(ngModel)]="registration.person.email" required />
            <div *ngIf="(submitted || email.dirty) && email.invalid" class="validationError">
              <span *ngIf="email.errors.required">{{ 'validation_required' | l10n:['#person_email'] }}</span>
              <span *ngIf="email.errors.email">{{ 'validation_email' | l10n:['#person_email'] }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row personal-data-field-phone">
          <label for="telephone" class="col-sm-4 col-form-label col-form-label-sm">{{ 'person_telephone' | l10n }}</label>
          <div class="col-sm-8">
            <input id="telephone" name="telephone" type="text" class="form-control" #telephone="ngModel" [(ngModel)]="registration.person.telephone" />
          </div>
        </div>

        <div class="form-separator"></div>

        <!-- Address - street, city, postcode, country -->
        <div class="form-group row">
          <label class="col-sm-4 col-form-label col-form-label-sm">{{ 'person_address'| l10n }}</label>
          <div class="col-sm-8">
            <div class="personal-data-name-format-msg" *ngIf="! otEvent.organization.requirePersonAddress">
              {{ 'personalData_address_info' | l10n }}
              <div class="show-address-fields" *ngIf="! addressVisible">
                <fa-icon icon="address-card"></fa-icon>&nbsp;
                <a (click)="addressVisible = true">{{ 'personAddress_showFields' | l10n }}</a>
              </div>
            </div>
          </div>
        </div>

        <div id="addressFields" *ngIf="addressVisible" [class.visible]="addressVisible">
          <div class="form-group row personal-data-field-address-street">
            <label for="street" class="col-sm-4 col-form-label col-form-label-sm" [class.required]="isAddressRequired()">{{ 'personAddress_street' | l10n }}</label>
            <div class="col-sm-8">
              <input id="street" name="street" type="text" class="form-control" #street="ngModel" [(ngModel)]="registration.person.address.street" [required]="isAddressRequired()" />
              <div *ngIf="(submitted || street.dirty) && street.invalid" class="validationError">
                <span *ngIf="street.errors.required">{{ 'validation_required' | l10n:['#personAddress_street'] }}</span>
              </div>
            </div>
          </div>
          <div class="form-group row personal-data-field-address-city">
            <label for="city" class="col-sm-4 col-form-label col-form-label-sm" [class.required]="isAddressRequired()">{{ 'personAddress_city' | l10n }}</label>
            <div class="col-sm-8">
              <input id="city" name="city" type="text" class="form-control" #city="ngModel" [(ngModel)]="registration.person.address.city" [required]="isAddressRequired()" />
              <div *ngIf="(submitted || city.dirty) && city.invalid" class="validationError">
                <span *ngIf="city.errors.required">{{ 'validation_required' | l10n:['#personAddress_city'] }}</span>
              </div>
            </div>
          </div>
          <div class="form-group row personal-data-field-address-postcode">
            <label for="postcode" class="col-sm-4 col-form-label col-form-label-sm" [class.required]="isAddressRequired()">{{ 'personAddress_postcode' | l10n }}</label>
            <div class="col-sm-8">
              <input id="postcode" name="postcode" type="text" class="form-control" #postcode="ngModel" [(ngModel)]="registration.person.address.postcode" [required]="isAddressRequired()" />
              <div *ngIf="(submitted || postcode.dirty) && postcode.invalid" class="validationError">
                <span *ngIf="postcode.errors.required">{{ 'validation_required' | l10n:['#personAddress_postcode'] }}</span>
              </div>
            </div>
          </div>
          <div class="form-group row personal-data-field-address-country">
            <label for="countryCode" class="col-sm-4 col-form-label col-form-label-sm" [class.required]="isAddressRequired()">{{ 'personAddress_country' | l10n }}</label>
            <div class="col-sm-8">
              <input id="countryCode" name="countryCode" type="text" class="form-control"
                  #countryCode="ngModel"
                  [(ngModel)]="registration.person.address.country"
                  [editable]="false"
                  [ngbTypeahead]="countryAutocomplete"
                  [inputFormatter]="countryInputFormatter"
                  [resultFormatter]="countryInputFormatter"
                  (blur)="countryBlured($event)"
                  (selectItem)="countrySelected($event)"
                  [required]="isAddressRequired()"
                  autocomplete="dont-autocomplete" />
              <div *ngIf="(submitted || countryCode.dirty) && countryCode.invalid" class="validationError">
                <span *ngIf="countryCode.errors.required">{{ 'validation_required' | l10n:['#personAddress_country'] }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="otEvent.organization.enableInformationSource && otEvent.organization.informationSources?.length > 0 || otEvent.organization.enableRegistrationReason && otEvent.organization.registrationReasons?.length > 0" class="form-separator">
        </div>

        <div *ngIf="otEvent.organization.enableInformationSource && otEvent.organization.informationSources?.length > 0" class="form-group row personal-data-field-informationSource">
          <label for="informationSourceId" class="col-sm-4 col-form-label col-form-label-sm">{{ 'registration_informationSourceAnswer' | l10n }}</label>
          <div class="col-sm-8">
            <app-information-source-selector
              name="informationSource"
              [informationSources]="otEvent.organization.informationSources"
              [(ngModel)]="registration.informationSourceAnswer"></app-information-source-selector>
          </div>
        </div>
        <div *ngIf="otEvent.organization.enableRegistrationReason && otEvent.organization.registrationReasons.length > 0" class="form-group row personal-data-field-registrationReasons">
          <label class="col-sm-4 col-form-label col-form-label-sm">{{ 'registration_registrationReasonAnswers' | l10n }}</label>
          <div class="col-sm-8">
            <app-registration-reason-answer-selector
              name="registrationReasonAnswers"
              [reasons]="otEvent.organization.registrationReasons"
              [(ngModel)]="registration.registrationReasonAnswers"></app-registration-reason-answer-selector>
          </div>
        </div>

        <div class="form-separator"></div>

        <div class="form-group row personal-data-field-notes">
          <label for="notes" class="col-sm-4 col-form-label col-form-label-sm">{{ 'registration_notes' | l10n }}</label>
          <div class="col-sm-8">
            <textarea id="notes" name="notes" class="form-control" [(ngModel)]="registration.notes"></textarea>
            <div class="personalData-questionsByEmailInfo"><fa-icon [icon]="['fas', 'info']"></fa-icon> {{ 'personalData_questionsByEmailInfo' | l10n:[otEvent.organization.email] }}</div>
          </div>
        </div>

        <!-- Personal data agreement -->
        <div class="form-group row" *ngIf="otEvent.organization.personalDataAgreement">
          <label class="col-sm-4 col-form-label col-form-label-sm">{{ 'personalData_personalDataProcessing_label' | l10n }}</label>
          <div class="col-sm-8">
            <div id="personalDataAgreement" [innerHtml]="otEvent.organization.personalDataAgreement"></div>
          </div>
          <div class="col-sm-8 offset-md-4">
            <label class="required"><input name="pdConsent" type="checkbox" #pdConsent="ngModel" [(ngModel)]="agreed" required /> {{ 'personalData_agreeWithPersonalDataProcessing' | l10n }}</label>
            <div *ngIf="submitted && pdConsent.invalid" class="validationError">
              <span>{{ 'personalData_personalDataProcessing_required' | l10n }}</span>
            </div>
          </div>
        </div>

        <!-- Terms and conditions -->
        <ng-template #termsAndConditionsTemplate let-modal>
            <div class="modal-header">
                <h4>{{ 'termsAndConditions_title' | l10n }}</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div>
                <p>{{ 'termsAndConditions_info' | l10n:[otEvent.organization.name] }}</p>
              </div>
                <div class="termsAndConditions" [innerHtml]="otEvent.organization.termsAndConditions"></div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" (click)="modal.close('OK');">{{ 'button_ok' | l10n }}</button>
            </div>
        </ng-template>

        <div class="form-group row" *ngIf="otEvent.organization.termsAndConditions">
          <div class="col-sm-8 offset-md-4">
            <label class="required"><input name="termsAndConditionsConsent" type="checkbox" #termsAndConditionsConsent="ngModel" [(ngModel)]="termsAgreed" required /> {{ 'personalData_agreeWithTermsAndConditions' | l10n }}</label>
            <div class="showPersonalDataAgreement"><a (click)="openTermsAndConditionsDialog(termsAndConditionsTemplate)">{{ 'personalData_showTermsAndConditions' | l10n }} <fa-icon [icon]="['fas', 'chevron-circle-right']"></fa-icon></a></div>
            <div *ngIf="submitted && termsAndConditionsConsent.invalid" class="validationError">
              <span>{{ 'personalData_termsAndConditionsConsent_required' | l10n }}</span>
            </div>
          </div>
        </div>

        <!-- Button -->
        <div class="form-group">
          <div class="col-sm-8 offset-md-4">
            <button type="button" *ngIf="! registration.paymentTypeConfig || ! registration.paymentTypeConfig.online" class="btn btn-primary mt1em" (click)="goToNextStep(personForm.valid)">{{ 'personalData_goToSummary' | l10n }} <fa-icon [icon]="['fas', 'chevron-right']" class="button-icon-right"></fa-icon></button>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <div class="selected-event-card">
          <app-ot-event-info [otEvent]="otEvent"></app-ot-event-info>
        </div>
        <div class="pricing-info-card" *ngIf="registration.paymentTypeConfig">
          <app-registration-pricing-info
            [registration]="registration"
            [changeLink]="'/city/' + city?.id + '/ot/event/' + otEvent?.id + '/registration/price'"></app-registration-pricing-info>
        </div>
      </div>
    </div>
  </div>
</form>
